import { c as _c } from "react/compiler-runtime";
import type { NavigationHeaderLeftButtonProps } from '@onefootprint/idv2';
import { HeaderTitle, NavigationHeader } from '@onefootprint/idv2';
import type { JSX } from 'react';
import Logo from '../logo';
type HeaderProps = {
  leftButton: NavigationHeaderLeftButtonProps;
  logoUrl?: string;
  orgName?: string;
  showLogo?: boolean;
  subtitle?: string | JSX.Element;
  title?: string | JSX.Element;
};
const StepHeader = t0 => {
  const $ = _c(11);
  const {
    leftButton,
    logoUrl,
    orgName,
    showLogo,
    subtitle,
    title
  } = t0;
  const shouldShowLogo = showLogo && orgName;
  let t1;
  if ($[0] !== leftButton) {
    t1 = <NavigationHeader leftButton={leftButton} />;
    $[0] = leftButton;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== logoUrl || $[3] !== orgName || $[4] !== shouldShowLogo || $[5] !== subtitle || $[6] !== title) {
    t2 = shouldShowLogo || title ? <div className="flex flex-col gap-6">{shouldShowLogo ? <Logo orgName={orgName} logoUrl={logoUrl} /> : null}{title ? <HeaderTitle title={title} subtitle={subtitle} /> : null}</div> : null;
    $[2] = logoUrl;
    $[3] = orgName;
    $[4] = shouldShowLogo;
    $[5] = subtitle;
    $[6] = title;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default StepHeader;